import { Alert, Stack } from '@backyard-ui/core'
import { generateSimpleId, formatters } from 'frontendMyOrders/utils'

import { Divider } from '../../componentsRefact'
import { useAppSelector } from '../redux/store'
import { MessageType } from '../types'
import { isSameDate } from '../utils/isSameDate'
import { MessageBox } from './MessageBox'

const SellerChat = () => {
  const messages = useAppSelector(state => state.messages)
  const properties = useAppSelector(state => state.properties)

  const nameForMessageBox = (from: string) => {
    switch (from) {
      case 'bot':
        return 'Leroy Merlin Automático'
      case 'user':
        return properties.data.userName
      case 'seller':
        return properties.data.shopName
      default:
        return 'Leroy Merlin Automático'
    }
  }

  const renderMessages = (messages: MessageType[]) => {
    const filteredMessages = messages.filter(message => message.from !== 'bot')

    return filteredMessages.map((message, index) => {
      const currentMessageDate = new Date(message.time)
      let showDivider = false

      if (index === 0) {
        showDivider = true
      } else {
        const previousMessageDate = new Date(messages[index - 1].time)
        showDivider = !isSameDate(currentMessageDate, previousMessageDate)
      }

      return (
        <div key={generateSimpleId()}>
          {showDivider && (
            <Divider
              text={formatters.formatDate(
                message.time,
                'long_weekday_day_month'
              )}
            />
          )}
          <MessageBox
            timestamp={formatters.formatDate(message.time, 'short_hour')}
            type={message.from}
            message={message.text}
            name={nameForMessageBox(message.from)}
            attachments={message.attachments}
            isOnMobileApp={properties.data.isOnMobileApp}
          />
        </div>
      )
    })
  }

  const shouldRenderMessages = messages?.data.list && properties

  if (!shouldRenderMessages) {
    return null
  }

  return (
    <Stack direction="column" spacing={4} className="m-4">
      <Alert.Root variant="subtle" appearance="warning">
        <Alert.Icon />

        <Alert.Content>
          <Alert.Title>Cuidado com golpes</Alert.Title>

          <Alert.Description>
            Para sua segurança, não compartilhe informações pessoais como dados
            bancários, senhas e cartões de crédito. Evite clicar em links
            externos.
          </Alert.Description>
        </Alert.Content>
      </Alert.Root>

      {renderMessages(messages.data.list)}
    </Stack>
  )
}

export default SellerChat
